import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class PdfFooter extends Component {
	render() {
		return <div className="pdf-footer">{this.props.children}</div>;
	}
}
PdfFooter.propTypes = {
	children: PropTypes.node
};
export default PdfFooter;
